import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentDetail } from '../../models/enrollment-detail';
import { EnrollmentService } from '../../services/enrollment.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-enrollment-info',
    templateUrl: './enrollment-info.component.html',
    styleUrls: ['./enrollment-info.component.scss']
})
export class EnrollmentInfoComponent implements OnInit {

    public headerTitle     : string = 'Inscripciones';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/inscripciones';

    public isLoadingData      : boolean = true;
    public loadingMessage     : AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    public enrollmentCode: string;
    public enrollment    : EnrollmentDetail;

    constructor(
        private activatedRoute: ActivatedRoute,
        private enrollmentService: EnrollmentService) { }

    ngOnInit(): void {

        this.enrollmentCode = this.activatedRoute.snapshot.params["code"];
        this.initData();

    }

    private initData() {

        forkJoin({

            enrollmentRequest: this.enrollmentService.getByCode(this.enrollmentCode)

        }).subscribe({

            next: (requests: any) => {

                this.enrollment = requests.enrollmentRequest;
            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
